<div class="modal-header" mat-dialog-title>
    <div class="modal-header-icon">
        <mat-icon class="material-symbols-outlined">payments</mat-icon>
    </div>
    <div class="modal-header-titles">
        <h2 class="modal-title">{{ lancou ? 'Financeiro lançado' : 'Lançar financeiro' }}</h2>
        <span class="modal-subtitle">{{ data.rotuloDocumento }}</span>
    </div>
    <div class="modal-header-close-btn-container">
        <button mat-icon-button type="button" class="modal-close-btn" aria-label="Fechar" (click)="fechar()">
            <mat-icon class="material-symbols-outlined">close</mat-icon>
        </button>
    </div>
</div>

<mat-dialog-content class="modal-content scroll-suave">
    @if (isLoading) {
        <app-loading-box height="56" width="100%" marginTop="0"></app-loading-box>
        <app-loading-box height="56" width="100%" marginTop="12"></app-loading-box>
    } @else if (resultado) {
        <!-- Depois do lançamento: só os boletos (DF6) e os links Pix a copiar; o retorno foi pelo toast. -->
        @if (resultado.boletosGerados; as boletos) {
            <div class="pvlf-bloco">
                <div class="pvlf-bloco-titulo">Boletos</div>
                <ul class="pvlf-lista-simples">
                    <li>{{ boletos.sucesso }} boleto(s) gerado(s).</li>
                    @if (boletos.semIntegracao > 0) {
                        <li class="pvlf-aviso">{{ boletos.semIntegracao }} boleto(s) não gerado(s): conta sem integração bancária.</li>
                    }
                    @if (boletos.falha > 0) {
                        <li class="pvlf-aviso">{{ boletos.falha }} boleto(s) com falha na emissão: reemita pelo contas a receber.</li>
                    }
                    @for (mensagem of boletos.mensagens; track $index) {
                        <li class="pvlf-mensagem">{{ mensagem }}</li>
                    }
                </ul>
            </div>
        }

        @if (resultado.linksCobranca.length) {
            <div class="pvlf-bloco">
                <div class="pvlf-bloco-titulo">Links de cobrança Pix</div>
                @for (link of resultado.linksCobranca; track link.idContasReceberParcela) {
                    <div class="pvlf-link">
                        <span class="pvlf-link-parcela">Parcela {{ link.nroParcela }}</span>
                        <span class="pvlf-link-url" [matTooltip]="linkCobranca(link.guidAcessoCobranca)">{{ linkCobranca(link.guidAcessoCobranca) }}</span>
                        <button mat-icon-button type="button" class="pvlf-link-copiar" matTooltip="Copiar link." aria-label="Copiar link"
                            (click)="copiarLink(link.guidAcessoCobranca)">
                            <mat-icon class="material-symbols-outlined">content_copy</mat-icon>
                        </button>
                    </div>
                }
            </div>
        }
    } @else if (!temItens) {
        <app-alert-card type="warning" title="Pedido sem recebimentos">
            Informe o pagamento do pedido antes de lançar o financeiro.
        </app-alert-card>
    } @else {
        <p class="descricao-modal">
            Cada recebimento vira um registro no Finanças, conforme a forma e a conta: entrada direta em conta
            caixa ou bancária (uma por parcela), ou título de contas a receber com as parcelas do pedido. Com
            intermediador, o vencimento segue o prazo dele e a taxa e a tarifa ficam previstas no título. Depois
            do lançamento o pedido fica em leitura; para editar, exclua o financeiro pelo menu Ações.
        </p>

        @for (item of itens; track item.sequencia) {
            <div class="pvlf-item">
                <div class="pvlf-item-cabecalho">
                    <mat-icon class="material-symbols-outlined pvlf-item-icone">{{ item.ehMovimentacao ? 'account_balance_wallet' : 'receipt_long' }}</mat-icon>
                    <div class="pvlf-item-titulos">
                        <span class="pvlf-item-forma">{{ item.sequencia }}. {{ item.forma }}</span>
                        <span class="pvlf-item-detalhe">Categoria: {{ item.categoria }}@if (item.conta) { · Conta: {{ item.conta }}}</span>
                    </div>
                    <span class="pvlf-item-valor">{{ item.valor | abnt:'preco':2 }}</span>
                </div>

                @if (item.erro) {
                    <app-alert-card type="warning">{{ item.erro }}</app-alert-card>
                } @else if (item.ehMovimentacao) {
                    <div class="pvlf-item-efeito">
                        @if (item.entradas.length > 1) {
                            {{ item.entradas.length }} movimentações de entrada na conta {{ item.conta }}, uma por parcela, no vencimento de cada uma.
                        } @else {
                            Movimentação de entrada na conta {{ item.conta }} na data da venda.
                        }
                    </div>
                    @if (item.entradas.length > 1) {
                        <table class="pvlf-parcelas">
                            @for (entrada of item.entradas; track $index) {
                                <tr>
                                    <td>{{ $index + 1 }}/{{ item.entradas.length }}</td>
                                    <td>{{ entrada.data | date:'dd/MM/yyyy' }}</td>
                                    <td class="pvlf-parcela-valor">{{ entrada.valor | abnt:'preco':2 }}</td>
                                </tr>
                            }
                        </table>
                    }
                } @else {
                    <div class="pvlf-item-efeito">
                        Título com {{ item.parcelas.length }} parcela(s)@if (!item.conta) { — sem conta (crediário)}@if (item.intermediador) { · pelo intermediador {{ item.intermediador }}@if (item.taxaPercentual != null) { (taxa {{ item.taxaPercentual | abnt:'quantidade':2 }}%)}}@if (item.ehBoleto) { · boleto}@if (item.ehPix) { · Pix com link de cobrança}
                    </div>
                    @if (item.parcelas.length) {
                        <table class="pvlf-parcelas">
                            @if (temTaxa(item) || temJuros(item)) {
                                <tr class="pvlf-parcelas-cabecalho">
                                    <th scope="col"></th>
                                    <th scope="col">Vencimento</th>
                                    <th scope="col" class="pvlf-parcela-valor">Valor</th>
                                    @if (temTaxa(item)) { <th scope="col" class="pvlf-parcela-valor">Taxa</th> }
                                    @if (temTarifaRateada(item)) { <th scope="col" class="pvlf-parcela-valor">Tarifa</th> }
                                    @if (temTaxa(item)) { <th scope="col" class="pvlf-parcela-valor">Líquido</th> }
                                    @if (temJuros(item)) { <th scope="col" class="pvlf-parcela-valor">Juros</th> }
                                </tr>
                            }
                            @for (parcela of item.parcelas; track parcela.numero) {
                                <tr>
                                    <td>{{ parcela.numero }}/{{ item.parcelas.length }}</td>
                                    <td>{{ parcela.vencimento | date:'dd/MM/yyyy' }}</td>
                                    <td class="pvlf-parcela-valor">{{ parcela.valor | abnt:'preco':2 }}</td>
                                    @if (temTaxa(item)) { <td class="pvlf-parcela-valor">{{ parcela.taxa | abnt:'preco':2 }}</td> }
                                    @if (temTarifaRateada(item)) { <td class="pvlf-parcela-valor">{{ parcela.tarifa | abnt:'preco':2 }}</td> }
                                    @if (temTaxa(item)) { <td class="pvlf-parcela-valor">{{ parcela.liquido | abnt:'preco':2 }}</td> }
                                    @if (temJuros(item)) { <td class="pvlf-parcela-valor">{{ parcela.juros | abnt:'preco':2 }}</td> }
                                </tr>
                            }
                        </table>
                    }
                    @if (item.tarifaSeparada; as tarifa) {
                        <div class="pvlf-item-efeito">
                            <mat-icon class="material-symbols-outlined pvlf-tarifa-icone">payments</mat-icon>
                            Tarifa do intermediador de {{ tarifa.valor | abnt:'preco':2 }}: saída na conta {{ tarifa.conta }} em {{ tarifa.data | date:'dd/MM/yyyy' }}.
                        </div>
                    }
                    @if (temJuros(item)) {
                        <div class="pvlf-item-efeito">Juros da condição previstos nas parcelas: {{ item.totalJuros | abnt:'preco':2 }}. O pedido não muda.</div>
                    }
                }
            </div>
        }

        <div class="pvlf-total">
            <span>Total dos recebimentos</span>
            <strong>{{ totalRecebimentos | abnt:'preco':2 }}</strong>
        </div>

        @if (temBoleto) {
            <!-- Mesmo texto do cadastro do contas a receber (contas-receber-cadastro, "Gerar boletos?"). -->
            <div class="pvlf-boleto">
                <mat-checkbox color="primary" [(ngModel)]="gerarBoletos">Gerar os boletos das parcelas agora</mat-checkbox>
                <div class="pvlf-boleto-custo">
                    Custo de bilhetagem: <strong>{{ custoBoletoUnitario | abnt:'preco':2 }}</strong> por boleto —
                    total <strong>{{ custoBoletoTotal | abnt:'preco':2 }}</strong> ({{ qtdParcelasBoleto }} parcela(s)).
                    Conta sem integração bancária não gera boleto; o título é criado mesmo assim.
                </div>
            </div>
        }
    }
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
    @if (lancou || (!isLoading && !temItens)) {
        <button mat-flat-button type="button" class="btn-primary" (click)="fechar()">Fechar</button>
    } @else {
        <button mat-stroked-button type="button" class="btn-secondary" [disabled]="isLancando" (click)="fechar()">Cancelar</button>
        <!-- Com erro em algum recebimento (condição comercial ou categoria da tarifa) o orquestrador recusaria: não lança. -->
        <button mat-flat-button type="button" class="btn-primary btn-spinner" [class.btn-loading]="isLancando"
            [disabled]="isLoading || isLancando || temErro" [attr.aria-label]="isLancando ? 'Lançando financeiro' : 'Lançar financeiro'"
            (click)="confirmar()">
            <mat-icon class="material-symbols-outlined">check</mat-icon>
            Lançar financeiro
            @if (isLancando) { <mat-spinner diameter="20"></mat-spinner> }
        </button>
    }
</mat-dialog-actions>
